var Price = /** @class */ (function () {
    function Price(obj, id) {
        if (id) {
            this.id = id;
        }
        this.status = obj.status;
        this.date = obj.date;
        this.time = obj.time;
    }
    Object.defineProperty(Price.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Price.prototype, "Status", {
        get: function () {
            return this.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Price.prototype, "Date", {
        get: function () {
            return this.date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Price.prototype, "Time", {
        get: function () {
            return this.time;
        },
        enumerable: false,
        configurable: true
    });
    return Price;
}());
export { Price };
export function createPrice(obj, id) {
    return new Price(obj, id);
}
export function createPrices(rawMPrices) {
    var prices = [];
    var rawPricesData = rawMPrices.data;
    for (var _i = 0, rawPricesData_1 = rawPricesData; _i < rawPricesData_1.length; _i++) {
        var rawPrice = rawPricesData_1[_i];
        var price = createPrice(rawPrice.attributes, rawPrice.id);
        prices.push(price);
    }
    return prices;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/price/price.ts
// module id = 145
// module chunks = 0